import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import "@testing-library/jest-dom";
import { FullPageChatLayout } from "./FullPageChatLayout";
import type { ConversationQueueItem } from "../hooks/useConversationQueue";

const defaults = {
  messages: [],
  isLoading: false,
  onSendMessage: jest.fn(),
  conversations: [],
  onLoadConversation: jest.fn(),
  onNewConversation: jest.fn(),
  onSearchConversations: jest.fn(),
  onLoadMoreConversations: jest.fn(),
  conversationsLoading: false,
  currentConversationId: 42,
  welcomeTitle: "Welcome",
  welcomeDescription: "",
  fetchMessageUsage: jest.fn(),
};

const queuedItem: ConversationQueueItem = {
  submission_id: "submission-1",
  status: "queued",
  position: 2,
  created_at: "2026-10-23T08:00:00Z",
};

it("renders queue status and cancel controls", () => {
  render(
    <FullPageChatLayout
      {...defaults}
      queuedMessages={[queuedItem]}
      onCancelQueuedMessage={jest.fn()}
      onCancelAllQueuedMessages={jest.fn()}
    />,
  );

  expect(screen.getByTestId("conversation-queue")).toHaveTextContent(
    "Queued message 2.",
  );
  expect(screen.getByRole("button", { name: "Cancel all" })).toBeVisible();
  expect(
    screen.getByRole("button", { name: "Cancel message 2" }),
  ).toBeVisible();
});

it("allows sending while busy and keeps the draft until queue admission is acknowledged", async () => {
  let acknowledge!: () => void;
  const onQueueMessage = jest.fn(
    () => new Promise<void>((resolve) => (acknowledge = resolve)),
  );
  render(
    <FullPageChatLayout
      {...defaults}
      isLoading
      onQueueMessage={onQueueMessage}
    />,
  );
  const textarea = screen.getByRole("textbox");
  fireEvent.change(textarea, { target: { value: "queued question" } });
  fireEvent.click(screen.getByRole("button", { name: "Queue message" }));

  expect(onQueueMessage).toHaveBeenCalledWith("queued question", []);
  expect(textarea).toHaveValue("queued question");

  acknowledge();
  await waitFor(() => expect(textarea).toHaveValue(""));
});

it("shows a failed-on-restart queue entry without a retry action", () => {
  render(
    <FullPageChatLayout
      {...defaults}
      queuedMessages={[
        {
          ...queuedItem,
          status: "failed",
          position: null,
          reason: "worker_restarted",
        },
      ]}
      onCancelQueuedMessage={jest.fn()}
    />,
  );

  expect(screen.getByTestId("conversation-queue")).toHaveTextContent(
    "Message failed because the worker restarted.",
  );
  expect(screen.queryByRole("button", { name: "Cancel message 2" })).toBeNull();
});
